import loadable from '@loadable/component';
import React from 'react';
import { BrowserRouter, Route, StaticRouter, Switch } from 'react-router-dom';

const HomePageWithStore = loadable(() => import('./home'));
const BrowsePageWithStore = loadable(() => import('./browse'));
const SearchPageWithStore = loadable(() => import('./search'));
const CategoryBrowsePage = loadable(() => import('./categoryBrowse'));
const PersonalizedBucketsHack = loadable(() => import('./personalized'));

const Router = (
    process.env.REACT_APP_TARGET === 'server' ? StaticRouter : BrowserRouter
) as React.ElementType;

export default function Routes(props: any) {
    const searchParams = new URLSearchParams(props.request.params).toString();
    return (
        <Router location={`${props.request.path}?${searchParams}`} context={{}}>
            <Switch>
                {/* /esi_cache is the request path when Varnish renders the page */}
                <Route
                    path="/esi_cache"
                    exact={true}
                    render={(routerProps) => (
                        <HomePageWithStore {...props} {...routerProps} />
                    )}
                />
                <Route
                    path="/"
                    exact={true}
                    render={(routerProps) => (
                        <HomePageWithStore {...props} {...routerProps} />
                    )}
                />
                <Route
                    path={`/:locale?/d/:locationSlug/events/`}
                    render={(routerProps) => (
                        <BrowsePageWithStore {...props} {...routerProps} />
                    )}
                />
                <Route
                    path={`/:locale?/b/:locationSlug/:category?/:subcategory?`}
                    render={(routerProps) => (
                        <CategoryBrowsePage {...props} {...routerProps} />
                    )}
                />
                <Route
                    path={`/:locale?/d/:locationSlug/:query`}
                    render={(routerProps) => {
                        return (
                            <SearchPageWithStore {...props} {...routerProps} />
                        );
                    }}
                />
                <Route
                    path={`/:locale?/d/personalized`}
                    render={(routerProps) => {
                        return (
                            <PersonalizedBucketsHack
                                {...props}
                                {...routerProps}
                            />
                        );
                    }}
                />
                {/* Fallback for when loading homepage with a
                locale configured. This ensures it verifies all others before attempting
                the wildcard. */}
                <Route
                    path="/:locale?/"
                    exact={true}
                    render={(routerProps) => (
                        <HomePageWithStore {...props} {...routerProps} />
                    )}
                />
            </Switch>
        </Router>
    );
}
